import { useEffect } from "react";

const SIZE_CLASSES = {
  sm: "max-w-md",
  md: "max-w-2xl",
  lg: "max-w-4xl",
  xl: "max-w-6xl",
};

export function Modal({ onClose, title, size = "md", children, dismissOnBackdrop = true }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-3 sm:p-6"
      onClick={(e) => { if (dismissOnBackdrop && e.target === e.currentTarget) onClose?.(); }}
    >
      <div className={`bg-white rounded-lg shadow-2xl w-full ${SIZE_CLASSES[size] || SIZE_CLASSES.md} max-h-[92vh] flex flex-col overflow-hidden`}>
        {title && (
          <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between shrink-0">
            <h3 className="font-semibold text-slate-900 text-sm">{title}</h3>
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-slate-700 w-6 h-6 flex items-center justify-center rounded hover:bg-slate-100"
              aria-label="Close"
            >×</button>
          </div>
        )}
        <div className="flex-1 overflow-hidden flex flex-col">
          {children}
        </div>
      </div>
    </div>
  );
}
